/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_HintInputs */

const cs_clients_roles_hint = /** @type {(inputs: Clients_Roles_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak s nimi pracujete — vyberte všechny platné role. Každá role odemkne vlastní pole.`)
};

const en_clients_roles_hint = /** @type {(inputs: Clients_Roles_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you work with them — pick every hat that applies. Each role unlocks its own fields.`)
};

/**
* | output |
* | --- |
* | "How you work with them — pick every hat that applies. Each role unlocks its own fields." |
*
* @param {Clients_Roles_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_hint = /** @type {((inputs?: Clients_Roles_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_hint(inputs)
	return cs_clients_roles_hint(inputs)
});